export const VOLATILITY_FILTER_OPTIONS = {
    Volatility_All: null,
    Volatility_None: 'NONE',
    Volatility_Low: 'LOW',
    Volatility_Medium: 'MEDIUM',
    Volatility_High: 'HIGH'
}